<!-- <p class="claim-depricated">This site has been archived; ongoing changes won't impact live claims, and customer communication has been discontinued here.</p> -->
<div class="row" >
  <div class="col-md-6 login-left text-center p-5 primary-background" style="background-color:#009B4C;margin-right: -30px;color: #ffffff;min-height:100vh;">
      
    <p style="font-size: 30px;font-weight: bold;text-align: center;"><img
      src={{applogo}}
      alt="DOWC"
      class="dark-logo"
      style="width: 140px;"
    /> Claims</p>
        <p style="font-size: 16px;text-align: center;">To start a GAP, Lease Wear & Tear, Key Protection, 360 Sheild, Debt Cancellation or Reimbursement claim, please create your account by click <a class="btn-link text-white" style="color: #fff;" href="/signup">here</a>. If you already have an account, please login to pick up where you left off.</p>
        <!-- <p class="mpad-t-5" style="font-size: 16px;text-align: center;">If you would like to start a claim for any other product, please click <a class="btn-link text-white" style="color: #fff;" href={{fileClaim}}>here</a>.<br/> Thank you! </p>-->
        <div class="help-container">
          <div class="help-section">
            <p class="help-text" (click)="openHelpPopup()">
              <i class="hellp-popup-icons"></i>
            </p>
          </div>
        </div>
      </div>  
  <div class="col-md-6 login-right text-center p-5 text-center p-5" style="min-height:100vh;">
    <div class="p-3 title-case" style="font-weight:bold; text-transform:uppercase;font-size: 24px;">
      <img class="dark-logo" style="width: 150px;" src={{logo}} alt="DOWC"> <span class="mt-1">
      </span>
    </div>
    <div class="card-body form-items" *ngIf="loginForm">
        <strong class="text-info float-left pb-2" *ngIf="!loginRequest">{{appname}} Claims will require 2-Step Verification to secure your account</strong>
        <strong class="text-warning float-left pb-2" *ngIf="loginRequest">Please enter the 6-digit OTP sent to your email and phone</strong>
        <form [formGroup]="loginForm" (ngSubmit)="execute()" class="form-horizontal form-material" id="loginform"
          novalidate>
          <p class="text-danger text-center f-11 mb-0 mt-2" *ngIf="!credentialError && error">
            <!-- <b>{{ error }}</b> -->
            <br/>
            <app-missed-errors></app-missed-errors>
          </p>
          <div class="form-group m-t-20" *ngIf="credentialError">
            <div class="error-login-card">
              <span>Provide a valid email address and password. If you continue to have issues logging into your account, contact our </span><a class="cursor-pointer" (click)="openHelpPopup()"><b>Support Team</b></a>
            </div>
          </div>
          <div class="form-group m-t-20" *ngIf="loginRequest==false">
            <div class="col-xs-12">
              <app-form-error-wrapper [control]="loginForm.controls['email']" [controlName]="'Email'"
                [apiErrorType]="'email'">
                 <input class="form-control" type="text" formControlName="email" placeholder="Enter email" [readonly]="loginRequest" />
                <!-- <input class="form-control" type="text" formControlName="email" placeholder="Enter email"
                  (click)="checkInput()" (change)="checkInput()" (keypress)="checkInput()" (keyup)="checkInput()" /> -->
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group" *ngIf="loginRequest==false">
            <div class="col-xs-12">
              <app-form-error-wrapper [control]="loginForm.controls['password']" [controlName]="'Password'"
                [apiErrorType]="'password'">
                  <div class="input-group input-group-merge form-password-toggle">
                    <input
                      class="form-control"
                      [type]="passwordTextType ? 'text' : 'password'"
                      formControlName="password"
                      placeholder="Password"
                      (keyup)="checkValidation()" (change)="checkValidation()"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text cursor-pointer"
                      (click)="passwordTextType = !passwordTextType;"
                        ><i
                          class="fa"
                          [ngClass]="{
                            'fa-eye-slash': passwordTextType,
                            'fa-eye': !passwordTextType
                          }"
                        ></i
                      ></span>
                    </div>
                  </div>
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-xl-0 col-12 col-xl-6 d-xl-flex align-items-centermb-3 p-0 m-t-20" *ngIf="loginRequest">
            <div class="form-group m-xl-0 col-12 col-xl-12 align-items-center p-0">
              <app-form-error-wrapper [control]="loginForm.controls['code']" [controlName]="'code'"
                [apiErrorType]="'code'">
                <input class="form-control" type="text" formControlName="code" placeholder="Enter OTP" mask="000000"
                  (keyup)="checkValidation()" (change)="checkValidation()"  [readonly]="otpsecounts === 0?true:false"/>
              </app-form-error-wrapper>
            </div>
            <!-- <div class="form-group m-xl-0 col-12 col-xl-12 align-items-center"
              *ngIf="counter===0 && otpRecieved===false">
              <button class="btn btn-white text-info" [disabled]="loginForm.invalid || isLoading1 || otpResent>2"
                (click)="resendSms()">
                <app-button-loader [isLoading]="isLoading1" [label]="'Request OTP'"></app-button-loader>
              </button>
            </div> -->
            <div class="form-group m-xl-0 col-12 col-xl-12 mp-l-0 align-items-center"
              *ngIf="counter===0 && otpRecieved===true && otpsecounts !== 0 && otpResent < 4">
              <button type="button" class="btn btn-info" [disabled]="isLoading1 || otpResent>3" (click)="resendSms()">
                <app-button-loader [isLoading]="isLoading1" [label]="'Resend OTP'"></app-button-loader>
              </button>
            </div>
            <!-- <div class="form-group m-xl-0 col-12 col-xl-2 align-items-center"
              *ngIf="otpRecieved && counter===0 && otpRecieved===true && otpsecounts !== 0">
              <button class="btn btn-white text-info" [disabled]="isLoading3 ||  otpResent>3" (click)="emailOTP()">
                <app-button-loader [isLoading]="isLoading3" [label]="'Email'"></app-button-loader>
              </button>
            </div>
            <div class="form-group m-xl-0 col-12 col-xl-2 align-items-center"
              *ngIf="otpRecieved && counter===0 && otpRecieved===true && otpsecounts !== 0">
              <button class="btn btn-white text-info" [disabled]="isLoading3 ||  otpResent>3" (click)="callOTP()">
                <app-button-loader [isLoading]="isLoading3" [label]="'Call'"></app-button-loader>
              </button>
            </div> -->
            <div class="form-group m-xl-0 col-12 col-xl-12 align-items-center" *ngIf="counter!=0">
              <h3 class="box-title m-b-0">{{counter}} Sec</h3>
            </div>
          </div>
          <div class="form-group text-left m-t-5 m-b-0 p-0" *ngIf="loginRequest && otpRecieved">
            <!-- <small class="success" *ngIf="otpsecounts!==0">Enter the 6 digits OTP code to login your account.</small> -->
            <small class="text-danger" *ngIf="otpsecounts === 0">Your OTP is expried, Please <a
                class="m-l-5 cursor-pointer" (click)="reLogin()"><b>relogin</b></a></small>
          </div>
          <div class="form-group">
            <ngx-invisible-recaptcha #captchaElem
              [siteKey]="siteKey"
              (success)="handleSuccess($event)"
              [ngModel]="recaptcha"
              [ngModelOptions]="{ standalone: true }">
            </ngx-invisible-recaptcha>
          </div>
          <div class="form-group m-t-2">
            <div class="col-xs-6">
              <button type="button" class="btn btn-primary pl-4 pr-4 mr-2" *ngIf="loginRequest && otpsecounts != 0" (click)="loginOtp()"
                [disabled]="loginForm.invalid || (loginRequest && loginForm.get('code').value.length !=6) || isLoading || isDisable">
                <app-button-loader [isLoading]="isLoading" [label]="'Login'">
                </app-button-loader>
              </button>
              <button class="btn btn-primary pl-4 pr-4 mr-2" *ngIf="!loginRequest"
                [disabled]="loginForm.invalid || (loginRequest && loginForm.get('code').value.length !=6) || isLoading || isDisable">
               <app-button-loader [isLoading]="isLoading" [label]="'Submit'"></app-button-loader>
              </button>
              <button type="button" class="btn btn-light bold pl-3 pr-3" *ngIf="loginRequest || (!loginRequest && isLoading)" (click)="reLogin()">
                <app-button-loader [label]="'Back'"></app-button-loader>
              </button>
            </div>
            <!-- <div class="col-xs-3">
              <button type="button" class="btn btn-black text-info bold pl-5 pr-5" *ngIf="loginRequest">
                <app-button-loader [isLoading]="isLoading" [label]="'Back'" (click)="reLogin()"></app-button-loader>
              </button>
            </div> -->
          </div>
          <div class="form-group m-t-2" *ngIf="!loginRequest">
            <div class="col-xs-3">
              <a class="m-l-5" [routerLink]="['/forgotpassword']">
                <b>Forgot Password</b>
              </a>
            </div>
          </div>
          <div class="form-group m-b-0" *ngIf="!loginRequest">
            <div class="col-sm-12 p-1">              
                Don't have an account?
                <a class="new-line" [routerLink]="['/signup']">
                  <b>Create one now</b>
                </a>
            </div>
          </div>
        </form>
      </div>
  </div>
    <div class="col-md-6 login-bottom text-center p-5 primary-background" style="background-color:#009B4C;margin-right: -30px;color: #ffffff;">
      <p style="font-size: 30px;font-weight: bold;text-align: center;">{{appname}} Claims</p>
          <p style="font-size: 16px;text-align: center;">To start a GAP, Lease Wear & Tear, Key Protection, 360 Sheild, Debt Cancellation or Reimbursement claim, please create your account by clicking on the link below. If you already have an account, please login to pick up where you left off.</p>
          <!-- <p class="mpad-t-5" style="font-size: 16px;text-align: center;">If you would like to start a claim for any other product, please click <a class="btn-link" style="color: #fff;" href={{fileClaim}}>here</a>.<br/> Thank you! </p>-->
        <div class="help-container">
          <div class="help-section">
            <p class="help-text" (click)="openHelpPopup()">
              <i class="hellp-popup-icons"></i>
            </p>
          </div>
        </div>
      </div>
</div>